__turbopack_context__.v({
  "description": "SBkita_description",
  "empty": "SBkita_empty",
  "title": "SBkita_title",
});
